"use strict";

(function (global) {

  /**  
  * Механизм запускающий JS функции из массива handlers когда происходит смена версии веб-доступа;
  * @namespace Core.migration
  * @since 5.2.0.1100
  * @return {boolean}
  * @example @see localStorage.js
  */
  global.migration = {
    handlers: [],

    init: function () {
      var newVersion = g_Version;
      var oldVersion = WA.cache.getItem('version');
      
      if (newVersion != oldVersion) {
        log.warning('DEFAULT', 'Version is changed. Running migration scripts');
        for (var handler in this.handlers) {
          this.handlers[handler].call(this, oldVersion, newVersion);
        };
        WA.cache.setItem('version', newVersion);
      };
    }
  };


})(window.Core);

